export default __webpack_public_path__ + "97550a6cf3bc8b2bcf4a3ce79479568f.png";